import { BaseAPI } from '../BaseApi';
import { ITitlePremiumResponse } from '../../types/title/ITitlePremiumResponse';
import { cleanupRequestWithNulls } from '../cleanupRequests';
import { IUpdateTitlePremiumRequest } from '../../types/title/IUpdateTitlePremiumRequest';

export const TitlePremiumApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    editTitlePremium: build.mutation<
      ITitlePremiumResponse,
      { orderId: string; body: IUpdateTitlePremiumRequest }
    >({
      query: (request) => ({
        url: `/timber/api/internal/orders/${request.orderId}/title-premium`,
        method: 'PATCH',
        body: cleanupRequestWithNulls(request.body),
      }),
    }),
  }),
});

export const { useEditTitlePremiumMutation } = TitlePremiumApi;
